import React, { useState } from 'react';
import { Button, message } from 'antd';
import useTranslation from '../../../hooks/translation/useTranslation';

function RenewButton({
  renewService,
  title,
}) {
  const { trans } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleRenew = async () => {
    setIsLoading(true);
    const res = await renewService();
    if (res?.data?.status === 'success') {
      message.success(trans('successfully_renewed'));
    }
    setIsLoading(false);
  };

  return (
    <div className="flex flex-col gap-2">
      <h1 className="m-0">{title}</h1>
      <Button
        className="w-fit"
        type="primary"
        onClick={handleRenew}
        loading={isLoading}
      >
        {trans('renew')}
      </Button>
    </div>
  );
}

export default RenewButton;
